import { RootState } from 'store/root-reducer';

export const jobTemplateSummarySelector = ({ jobTemplate }: RootState) => jobTemplate.summary;

export const jobTemplateOptionSelector = ({ jobTemplate }: RootState) => jobTemplate.options;
